// extracted by mini-css-extract-plugin
export default {"sectionRoot":"TitledSection_sectionRoot__uZa0K"};